import { Component, HostListener } from "@angular/core";
import { ChangeDetectorRef } from "@angular/core";
import { PrintDistributionService } from "./service/print-distribution.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ProcessedDistribution } from "client/app/domains/ProcessedDistribution";
import { concatMap } from "rxjs/operators";
import { IUserProfile } from "@neb/lit-storybook";
import { GemsService } from "client/app/shared/services";

@Component({
  selector: "app-print-distribution",
  templateUrl: "./print-distribution.component.html",
  styleUrls: ["./print-distribution.component.less"],
  standalone: false
})
export class PrintDistributionComponent {
  processedDistributions: ProcessedDistribution[];
  processedDistribution: ProcessedDistribution;
  processedDistributionId: string;

  constructor(
    private printDistributionService: PrintDistributionService,
    private route: ActivatedRoute,
    private router: Router,
    private changeDetector: ChangeDetectorRef,
    private gemsService: GemsService
  ) {
    this.gemsService.getUser().pipe(
      concatMap((user: IUserProfile) => this.printDistributionService.loadData(user.person_id)),
    ).subscribe((data: any) => {
      this.processedDistributionId = this.route.snapshot.paramMap.get("RetirementSpdId");
      this.processedDistributions = data.ProcessedDistributions;

      for (const processedDstribution of data.ProcessedDistributions) {
        if (processedDstribution.RetirementSpdId === this.processedDistributionId) {
          this.processedDistribution = processedDstribution;
        }
      }

      this.changeDetector.detectChanges();
      this.printAndNavigate();
    });
  }

  printAndNavigate() {
    window.print();
  }

  @HostListener('window:afterprint', ['$event'])
  onAfterPrint(event: Event): void {
    this.router.navigateByUrl('/admin/retirement-plan-documents');
  }
}
